import { reactive } from "vue";

const state = reactive({
  toasts: [],
});

let toastId = 0;

export function showToast({ message, type = "info", duration = 4000 }) {
  const id = ++toastId;
  state.toasts.push({ id, message, type });
  if (duration > 0) {
    setTimeout(() => dismissToast(id), duration);
  }
  return id;
}

export function dismissToast(id) {
  const index = state.toasts.findIndex((t) => t.id === id);
  if (index >= 0) state.toasts.splice(index, 1);
}

export function getToastState() {
  return state;
}

export const toastService = {
  success: (message) => showToast({ message, type: "success" }),
  error: (message) => showToast({ message, type: "error" }),
  info: (message) => showToast({ message, type: "info" }),
  warning: (message) => showToast({ message, type: "warning" }),
};
